





























































import Vue, { PropOptions } from 'vue';
import util from '@/components/util';
import SearchBox from '@/components/util/SearchBoxV3.vue';
import BasicGadget, {CFrame} from '@/components/gadgets/BasicGadget.vue';
import * as models from '@/class/models/views/graph';
import Gadgets from '@/components/gadgets';


export interface ISettings {
  edit: boolean;
  add: boolean;
  tab: boolean;
}

export class CSettings implements ISettings {
  public edit = false;
  public add  = false;
  public tab = false;
}

export default Vue.extend({
  name: 'GadgetListV3',
  components: {
    ...util,
    SearchBox, BasicGadget,
  },
  props: {
    gadgets: Array as PropOptions<models.IGadget[]>,
    settings: {
      type: Object as () => ISettings,
      default: () => new CSettings(),
    },
    addGadgetLock: {
      type: Function,
    },
  },
  data() {
    return {
      searchValue: '',
      selectGadgets: [] as models.IGadget[], // 送るガジェットが複数になる
      componentGadgets: Gadgets,
      frameDataDefault: new CFrame(),
      frameDataSample: new CFrame(),
      actives: [] as string[],
      selectCardNum: [] as string[],
      selectedX: 0,
      selectedY: 0,
      positionSet: '',
      isTaller: false,
      titleList: [
        {
          id: 'sample',
          title: 'サンプルグラフを表示',
        },
        {
          id: 'kojin',
          title: '作成グラフを表示',
        },
      ],
    };
  },
  computed: {
    DISP_LIST() {
      const gadgets: models.IGadget[] = this.gadgets.filter((v) => (v.title.indexOf(this.searchValue) >= 0));
      const returnGadgets = {
        sample: gadgets.filter((v) => (v.default)),
        kojin: gadgets.filter((v) => (!v.default)),
        share: [],
      };
      // console.log(this.tab);
      return returnGadgets;
    },
  },
  mounted() {
    // this.frameData.show = false;
    this.frameDataDefault.cover = true;
    this.frameDataSample.cover = true;
    this.frameDataSample.sample = true;
    this.actives = this.titleList.map((v) => v.id);
  },
  methods: {
    onClickGadget(select: models.IGadget, key: any ) {
      // 配列へ追加/削除
      if (this.selectCardNum.includes(key)) { // 削除
        const index = this.selectCardNum.indexOf(key);
        const gadIndex = this.selectGadgets.indexOf(select);
        if ((index > -1) && (gadIndex > -1)) {
          this.selectCardNum.splice(index, 1);
          this.selectGadgets.splice(gadIndex, 1);
        }
      } else { // 追加
        this.selectCardNum.push(key);
        this.selectGadgets.push(select);
      }
    },
    onClickGadgetEdit(select: models.IGadget) {
      this.$emit('edit', select);
      this.$emit('close');
    },
    onClickGadgetDelete(gadgetID: number) {
      this.$emit('delete', gadgetID);
    },
    // 選択をリセットする
    resetSelectGadget() {
      this.selectCardNum.splice(0);
      this.selectGadgets.splice(0);
    },
    async onClickGadgetAdd() {
      if (this.addGadgetLock(this.selectGadgets.length - 1)) {
        this.$emit('info', 'タブ内にグラフは13個以上登録できません。');
        return;
      }
      for (const gadget of this.selectGadgets) {
        this.$emit('add', gadget);
        // gadgetnumberを一意にするため時間をずらす
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      this.$emit('registview');
      this.$emit('close');
    },
    // onDragStartGadget(gadget: models.IGadget) {
    //   this.$emit('holding', gadget);
    // },
    // onDragEndGadget() {
    //   this.$emit('holding', {});
    // },
    generateModal() {
      this.$emit('generate');
    },
    getGadgetName(gadgetName: string) {
      // 第二次デザインで作られたグラフは新旧デザインを切り替える
      // 第三次デザインで作られたグラフはそのまま表示
      return gadgetName.indexOf('V3') === -1 ? gadgetName + 'V3' : gadgetName;
    },
  },
});

